// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Diagnostic } from "@ionic-native/diagnostic";
import { isCapacitorPlatform } from "@src/appV2/lib/utils";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";

import { CameraPermissionErrorBottomSheet } from "../../components/CameraPermissionErrorBottomSheet";

interface DocumentCameraPermissionErrorBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentCameraPermissionErrorBottomSheet(
  props: DocumentCameraPermissionErrorBottomSheetProps
) {
  const { modalState } = props;

  return (
    <CameraPermissionErrorBottomSheet
      modalState={modalState}
      onGoToSettings={async () => {
        modalState.closeModal();

        if (isCapacitorPlatform()) {
          await Diagnostic.switchToSettings();
        }
      }}
    />
  );
}
